'use strict';

import angular from 'angular';
import ShowController from './show.controller';

export default angular.module('updateServerApp.booklist.show', [])
  .controller('BookListShowController', ShowController)
  .name;



// WEBPACK FOOTER //
// ./client/app/booklist/show/index.js